export default __webpack_public_path__ + "static/media/ic_shield.d580cec8.svg";